module.exports = __webpack_public_path__ + "static/media/Frame 312.db5ad0fe.png";